import {
  type Type,
  getMeta,
  getSystem,
  withMeta,
  withSystem,
} from '@packages/systems/wfdl';
import {
  listTypeName,
  TElement,
  TTypeApplication,
  TTypeConstructor,
} from '@packages/systems/wfdl-ast';

/**
 * Returns true if the argument provded is a `Children` DataType field, false
 * otherwise.
 */
const isChildrenDataType = (dataType: Type): boolean =>
  Boolean(
    // @ts-expect-error - TS2367 - This comparison appears to be unintentional because the types '"Element" | "Unknown" | "Generic" | "TypeReference" | "TypeConstructor" | "TypeApplication" | "RowEmpty" | "RowCons" | "Rigid"' and '"Children"' have no overlap.
    dataType && typeof dataType === 'object' && dataType.type === 'Children'
  );

/**
 * Given a `Children` DataType field, return an equivalent `List<Element>`
 * DataType field
 */
const childrenToListOfElementField = (dataType: Type): Type => {
  return withSystem(
    {...getSystem(dataType)},
    TTypeApplication({
      con: TTypeConstructor(listTypeName),
      arg: withMeta({...getMeta(dataType)}, TElement),
    })
  );
};

// Given a DataType, find all `Children` type entries wihin the `Record`
// structures of that DataType and convert those to use `List<Element>` instead.
// This is a remnant of a special type we used at the beginning of component
// overrides to depict the type of children on a node.
export const migrateChildrenDataTypeToListOfElement = (
  dataType: Type
): Type => {
  if (isChildrenDataType(dataType)) {
    return childrenToListOfElementField(dataType);
  }
  return dataType;
};
